<em class="fal {{icon}} mr-1 fa-2x " [ngClass]="message.icon == icon ? 'font-bold' : ''"
    (click)="message.icon = icon"></em>
